import { createSlice } from "@reduxjs/toolkit";

export const setupSlice = createSlice({
  name: "setupDetails",

  initialState: {
    isProjectSetup: false,
    allGuidelinesWcag: {},
    wcagGuidelinesPayload: {
      selectedVersionsPayload: ["2.0", "2.1"],
      selectAllAPayload: true,
      selectAllAAPayload: true,
      listADataPayload: [],
      listAADataPayload: [],
    }
  },

  reducers: {
    setIsProjectSetup(state, action) {
      state.isProjectSetup = action.payload;
    },
    setAllGuidelinesWcag(state, action){
        state.allGuidelinesWcag = action.payload;    
    },
    setWcagGuidelinesPayload(state, action){
      state.wcagGuidelinesPayload = action.payload;    
  }
  
  },
});

export const { setIsProjectSetup, setAllGuidelinesWcag, setWcagGuidelinesPayload } = setupSlice.actions;
